import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
  async EncabezadoReporte() {
    let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    formData.append("aiclave", datos.aiclave);
    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/EncabezadoReporte`,
      formData
    );
    return response.data[0];
  },
  async EncabezadoReporteParams(nrreporte, svindice, aiclave) {
    var formData = new FormData();
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    formData.append("aiclave", aiclave);
    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/EncabezadoReporte`,
      formData
    );
    return response.data[0];
  },
  async DatosDetalle(vm) {
    let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}ExpJur/DetalleGeneral`,
      datosReporte
    );
    return response.data;
    //return vm.axios.post(`${vm.domain.domainNameForApi}ExpJur/DetalleGeneral`, datosReporte).then(response => response.data);
  },
  /* async CatalagoLesiones(vm) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ExpJur/CatalagoLesiones`)
      .then((response) => {
        vm.tipoLesiones = response.data;
      });
  }, */

  async CatalogoOpcionesMenu(datos, aiclave) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", aiclave);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/CatalogoGenerico`,
      datosReporte
    );

    return response.data;
  },

  async ObtenerCatalogoGenerico(datos, tipo, apartado) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);
    datosReporte.append("tipo", tipo);
    datosReporte.append("apartado", apartado);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/CatalogoGenerico`,
      datosReporte
    );

    return response.data;
  },

  async ObtenerCatalogoJuiciosOralesApartado1(datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/CatalogoJuiciosOralesDenunciaQuerella`,
      datosReporte
    );

    return response.data;
  },

  async ObtenerCatalogoJuiciosOralesApartado2(datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/CatalogoJuiciosOralesJudicializacion`,
      datosReporte
    );

    return response.data;
  },

  async ObtenerCatalogoJuiciosOralesExtraInfo(datos, tipo, apartado) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);
    datosReporte.append("tipo", tipo);
    datosReporte.append("apartado", apartado);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/CatalogoExtraInfo`,
      datosReporte
    );

    return response.data;
  },

  async ObtenerOpcionesTramites(datos, uslogin) {
    var datosReporte = new FormData();
    datosReporte.append("aiclave", datos.aiclave);
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("uslogin", uslogin);
    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ReporteObtenerOpcionesTramites`,
      datosReporte
    );
    return response.data;
  },

  async ObtenerDatosGeneralesMovimiento(datos, claveMovimiento) {
    var datosReporte = new FormData();
    datosReporte.append("claveMovimiento", claveMovimiento);
    datosReporte.append("claveAsistencia", datos.aiclave);
    datosReporte.append("reporte", datos.nrreporte);
    datosReporte.append("indice", datos.svindice);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/FormularioMovimiento`,
      datosReporte
    );

    return response.data;
  },

  async ObtenerEspecificosMovimiento(datos, claveMovimiento, respuesta) {
    var datosReporte = new FormData();
    datosReporte.append("claveMovimiento", claveMovimiento);
    datosReporte.append("claveAsistencia", datos.aiclave);
    datosReporte.append("respuesta", respuesta);
    datosReporte.append("reporte", datos.nrreporte);
    datosReporte.append("indice", datos.svindice);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/GeneraFormularioMovimiento`,
      datosReporte
    );
    return response.data;
  },

  async validaNuevoMovimiento(datos, claveMovimiento, respuesta, tipoProceso) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);
    datosReporte.append("claveMovimiento", claveMovimiento);
    datosReporte.append("respuesta", respuesta);
    datosReporte.append("tipoProceso", tipoProceso);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/ValidaNuevoMovimiento`,
      datosReporte
    );

    return response.data;
  },

  async obtenerCorreosPorZona(vm, claveZona) {
    var datos = new FormData();
    datos.append("valorZona", claveZona);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/ListadoCorreosPorZona`,
      datos
    );

    return response.data;
  },

  async guardarMovimiento(vm, jsonData) {
    var datos = new FormData();
    datos.append("data", jsonData);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/GuardarMovimientosJson`,
      datos
    );

    return response.data;
  },

  async editCampo(datos, tabla, campo, newValor) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);
    datosReporte.append("tabla", tabla);
    datosReporte.append("campo", campo);
    datosReporte.append("newValor", newValor);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/EditCampoProceso`,
      datosReporte
    );

    return response.data;
  },

  async validacionLiberacionFisica(datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/ReporteObtenerValidacionLiberacionFisica`,
      datosReporte
    );

    return response.data;
  },

  async obtenerADispocisionAutoridad(datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/ReporteObtenerValidacionDisposicionAutoridad`,
      datosReporte
    );

    return response.data;
  },

  async obtenerCorralones(datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/ReporteObtenerOpcionesCorralon`,
      datosReporte
    );

    return response.data;
  },

  async actualizaCorralon(datos, prclaveCO) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("prclaveCO", prclaveCO);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/ReporteActualizaCorralon`,
      datosReporte
    );

    return response.data;
  },

  async validaDisposicion(datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/ReportevalidaDisposicion`,
      datosReporte
    );

    return response.data;
  },

  async reporteObtenerEditCampoInfo(datos, ieapid) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);
    datosReporte.append("ieapid", ieapid);
    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/ReporteObtenerEditCampoInfo`,
      datosReporte
    );
    return response.data;
  },
  async reporteEditCampoInfo(datos, ieapid, value) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);
    datosReporte.append("ieapid", ieapid);
    datosReporte.append("newValue", value);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/reporteEditCampoInfo`,
      datosReporte
    );

    return response.data;
  },
  async obtenervalConclusion(vm, datos) {
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    axios
      .post(`${domain.domainNameForApi}ExpJur/ValidarConclusion`, formData)
      .then((response) => {
        vm.cerrado = response.data;
      });
  },

  //Volante
  async obtenerDatosAsegurado(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/obtenerDatosAsegurado`,
      formData
    );

    return response.data;
  },
  obtenerPasadaAlto(vm) {
    var formData = new FormData();
    formData.append("pdatipo", "A");
    formData.append("pdaactivo", 1);
    axios
      .post(`${domain.domainNameForApi}ExpJur/ObtenerPasadaAlto`, formData)
      .then((response) => {
        vm.opcionesPasadaAlto = response.data;
      });
  },

  async obtenerPermisoEliminar(vm) {
    var formData = new FormData();
    axios
      .post(`${domain.domainNameForApi}ExpJur/obtenerPermisoEliminar`, formData)
      .then((response) => {
        vm.permisoEliminar = response.data;
      });
  },
  async obtenerdoctosConclusion(vm) {
    var formData = new FormData();
    axios
      .post(
        `${domain.domainNameForApi}ExpJur/obtenerdoctosConclusion`,
        formData
      )
      .then((response) => {
        vm.DoctosArray = response.data;
        if (
          vm.d3foliodanios != "" &&
          vm.d3foliodanios != null &&
          vm.datos.termino == "R"
        ) {
          const docto = vm.doclave;
          vm.datos.tipoDocto = docto;
        }
      });
  },
  async obtenerNivel1(vm) {
    var formData = new FormData();
    formData.append("ftclave", vm.datos.termino);
    axios
      .post(`${domain.domainNameForApi}ExpJur/obtenerNivel1`, formData)
      .then((response) => {
        vm.listnivel1 = response.data;
      });
  },
  async obtenerNivel2(vm) {
    var formData = new FormData();
    formData.append("ftclave", vm.datos.termino);
    formData.append("ftn1clave", vm.datos.nivel1);
    axios
      .post(`${domain.domainNameForApi}ExpJur/obtenerNivel2`, formData)
      .then((response) => {
        vm.listnivel2 = response.data;
      });
  },
  async obtenerMarcas(vm) {
    var formData = new FormData();
    axios
      .post(`${domain.domainNameForApi}ExpJur/obtenerMarcas`, formData)
      .then((response) => {
        vm.opcionesMarca = response.data;
      });
  },
  async obtenerModelos(vm, value) {
    var formData = new FormData();
    formData.append("mrclave", value);
    axios
      .post(`${domain.domainNameForApi}ExpJur/obtenerModelos`, formData)
      .then((response) => {
        vm.opcionesModelos = response.data;
      });
  },
  async obtenerAseguradoras(vm) {
    var formData = new FormData();
    axios
      .post(`${domain.domainNameForApi}ExpJur/obtenerAseguradoras`, formData)
      .then((response) => {
        vm.opcionesAseguradoras = response.data;
      });
  },
  async obtenerDatosTercero(vm, d3id) {
    var formData = new FormData();
    formData.append("d3id", d3id);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/obtenerDatosTercero`,
      formData
    );

    return response.data;
  },

  async obtenerTelefonosTercero(vm, d3id) {
    var formData = new FormData();
    formData.append("d3id", d3id);

    return axios
      .post(
        `${domain.domainNameForApi}ExpJur/obtenerTelefonosTercero`,
        formData
      )
      .then((response) => response.data);
  },

  async eliminarTelefonoTercero(vm, item) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    formData.append("stid", item.stid);
    return axios
      .post(
        `${domain.domainNameForApi}ExpJur/eliminarTelefonoTercero`,
        formData
      )
      .then((response) => response.data);
  },

  async obtenerDatosValidaVolante(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/obtenerDatosValidaVolante`,
      formData
    );

    return response.data;
  },

  async eliminarTercero(vm, d3id) {
    var formData = new FormData();
    formData.append("d3id", d3id);
    return axios
      .post(`${domain.domainNameForApi}ExpJur/eliminarTercero`, formData)
      .then((response) => response.data);
  },

  async obtenerTipoTelefono(vm) {
    var formData = new FormData();
    axios
      .post(`${domain.domainNameForApi}ExpJur/obtenerTipoTelefono`, formData)
      .then((response) => {
        vm.opcionestipotelf = response.data;
      });
  },

  async guardarTelefonoTercero(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    formData.append("d3id", vm.d3id);
    formData.append("sttid", vm.datos.sttid.sttid);
    formData.append("stprefijo", vm.prefijo);
    formData.append("stnumero", vm.datos.numtelf2.split(/\s+/).join(""));
    formData.append("stverificado", 0);
    formData.append("stpais", vm.pais);
    return axios
      .post(`${domain.domainNameForApi}ExpJur/guardarTelefonoTercero`, formData)
      .then((response) => response.data);
  },
  async editarTelefonoTercero(vm) {
    var formData = new FormData();
    formData.append("stid", vm.datosTelefono.stid);
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    formData.append("staid", vm.datosTelefono.staid);
    formData.append("sttid", vm.datos.sttid.sttid);
    formData.append("stprefijo", vm.prefijo);
    formData.append("stnumero", vm.datos.numtelf2.split(/\s+/).join(""));
    formData.append("stverificado", 0);
    formData.append("stpais", vm.pais);
    formData.append("d3id", vm.d3id);
    return axios
      .post(`${domain.domainNameForApi}ExpJur/editarTelefonoTercero`, formData)
      .then((response) => response.data);
  },
  async guardarTercero(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    formData.append("datos", JSON.stringify(vm.datos));
    formData.append("telefonos", JSON.stringify(vm.telefonos));

    return axios
      .post(`${domain.domainNameForApi}ExpJur/guardarTercero`, formData)
      .then((response) => response.data);
  },

  async modificarTerceros(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    formData.append("datos", JSON.stringify(vm.datos));
    formData.append("d3id", vm.d3id);

    return axios
      .post(`${domain.domainNameForApi}ExpJur/ModificarTerceros`, formData)
      .then((response) => response.data);
  },

  async editarAsegurado(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    formData.append("datos", JSON.stringify(vm.datos));

    return axios
      .post(`${domain.domainNameForApi}ExpJur/EditarAsegurado`, formData)
      .then((response) => response.data);
  },

  async editarAutoridad(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    formData.append("autoridad", vm.datos.saautoridad);
    return axios
      .post(`${domain.domainNameForApi}ExpJur/EditarAutoridad`, formData)
      .then((response) => response.data);
  },

  async agregarOcupantes(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    formData.append("nombre", vm.datosOcPas.nombre);
    formData.append(
      "telefono",
      vm.datosOcPas.numtelf == null || vm.datosOcPas.numtelf == ""
        ? null
        : "(+" +
        vm.prefijo +
        ")" +
        vm.datosOcPas.numtelf.replace(/[^0-9]+/g, "")
    );
    formData.append("tipoOcup", vm.datosOcPas.tipo);
    formData.append("lesiones", vm.datosOcPas.lesiones);
    formData.append("homicidio", vm.datosOcPas.homicidios);
    formData.append("tipoLesiones", vm.datosOcPas.lclave);

    return axios
      .post(`${domain.domainNameForApi}ExpJur/AgregarOcupantes`, formData)
      .then((response) => response.data);
  },
  async VerificarDesconclusion(datos) {
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    return axios
      .post(`${domain.domainNameForApi}ExpJur/VerificarDesconclusion`, formData)
      .then((response) => response.data);
  },
  async obtenerEstatusListado(vm) {
    var formData = new FormData();
    formData.append("d3id", vm.displayInputs.d3id);

    return axios
      .post(`${domain.domainNameForApi}ExpJur/ObtenerEstatusListado`, formData)
      .then((response) => response.data);
  },
  async obtenerDatosNegociacion(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    formData.append("d3id", vm.displayInputs.d3id);
    return axios
      .post(
        `${domain.domainNameForApi}ExpJur/ObtenerDatosNegociacion`,
        formData
      )
      .then((response) => response.data);
  },

  async insertarNegociacion(vm) {
    var formData = new FormData();
    formData.append("d3id", vm.displayInputs.d3id);
    formData.append("datos", JSON.stringify(vm.datos));

    return axios
      .post(`${domain.domainNameForApi}ExpJur/InsertarNegociacion`, formData)
      .then((response) => response.data);
  },

  async valFirmaElectronica(vm) {
    var formData = new FormData();
    formData.append("usfirma", vm.datos.firma);
    return axios
      .post(`${domain.domainNameForApi}ExpJur/ValFirmaElectronica`, formData)
      .then((response) => response.data);
  },
  async insertarRespuestaNegociacion(vm) {
    var formData = new FormData();
    formData.append("d3id", vm.displayInputs.d3id);
    formData.append("ngid", vm.datos.ngid);
    formData.append("ngautorizacion", vm.datos.respneg);
    formData.append("ngobsautorizacion", vm.datos.observaciones);
    if (vm.datos.respneg == "0")
      formData.append("ngmontoaseg", vm.datos.montorango);
    else {
      var forma = vm.datos.formaRecuperacion.label;
      formData.append("ngqautorizo", vm.datos.observacionesAutoriza);
      formData.append("ngrecuperacion", forma);
    }
    formData.append("ngfecha", vm.datos.fecharespuesta);
    return axios
      .post(
        `${domain.domainNameForApi}ExpJur/InsertarValidacionNegociacion`,
        formData
      )
      .then((response) => response.data);
  },
  async insertarNegociacionCierre(vm) {
    var formData = new FormData();
    formData.append("d3id", vm.displayInputs.d3id);
    formData.append("ngfhalta", vm.datos.fecharespuesta);
    formData.append("ngobs", vm.datos.observaciones);
    formData.append("tipo", vm.datos.tipoNegociacion);

    return axios
      .post(
        `${domain.domainNameForApi}ExpJur/InsertarNegociacionCierre`,
        formData
      )
      .then((response) => response.data);
  },

  async obtenerDatosNegociacionValidacion(vm) {
    var formData = new FormData();
    formData.append("d3id", vm.displayInputs.d3id);
    return axios
      .post(
        `${domain.domainNameForApi}ExpJur/ObtenerDatosNegociacionValidacion`,
        formData
      )
      .then((response) => response.data);
  },
  async obtenerInfoDanios(vm) {
    var formData = new FormData();
    formData.append("d3id", vm.displayInputs.d3id);
    return axios
      .post(`${domain.domainNameForApi}ExpJur/ObtenerInfoDanios`, formData)
      .then((response) => response.data);
  },
  async concluirDanos(vm) {
    var formData = new FormData();
    formData.append("d3id", vm.displayInputs.d3id);
    formData.append("datos", JSON.stringify(vm.datos));

    return axios
      .post(`${domain.domainNameForApi}ExpJur/ConcluirDanos`, formData)
      .then((response) => response.data);
  },
  async limpiarConclusionDanos(vm) {
    var formData = new FormData();
    formData.append("d3id", vm.displayInputs.d3id);

    return axios
      .post(`${domain.domainNameForApi}ExpJur/LimpiarConclusionDanos`, formData)
      .then((response) => response.data);
  },
  async concluirLesyHom(vm) {
    var formData = new FormData();
    formData.append("d3id", vm.displayInputs.d3id);
    formData.append("datos", JSON.stringify(vm.datos));

    return axios
      .post(`${domain.domainNameForApi}ExpJur/ConcluirLesyHom`, formData)
      .then((response) => response.data);
  },
  async limpiarConclusionLesiones(vm) {
    var formData = new FormData();
    formData.append("d3id", vm.displayInputs.d3id);

    return axios
      .post(
        `${domain.domainNameForApi}ExpJur/LimpiarConclusionLesiones`,
        formData
      )
      .then((response) => response.data);
  },

  async MovAutConclusuion(datos) {
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    return axios
      .post(
        `${domain.domainNameForApi}ExpJur/Conclusion_MovAutorizado`,
        formData
      )
      .then((response) => response.data);
  },
  async MovSolicitud(datos) {
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    return axios
      .post(
        `${domain.domainNameForApi}ExpJur/Conclusion_MovSolicitud`,
        formData
      )
      .then((response) => response.data);
  },
  ObtenerDatosNegociacionUltimo(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ExpJur/ObtenerDatosNegociacionUltimo`,
        data
      )
      .then((response) => response.data);
  },
  //ObtenerDatosNegociacionUltimo(data) {
  //  return axios
  //    .post(
  //      `${domain.domainNameForApi}ExpJur/ObtenerDatosNegociacionUltimo`,
  //      data
  //    )
  //    .then((response) => response.data);
  //},
  InsertaRecuperacion(data) {
    return axios
      .post(`${domain.domainNameForApi}ExpJur/InsertaRecuperacion`, data)
      .then((response) => response.data);
  },
};
